import { ReactNode } from 'react';
import { Box } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography';

interface props {
  children: ReactNode;
}

const LabelBox = ({ children }: props) => {
  return (
    <Box py="10px" bg="gray-3" borderRadius="8px" width="100%">
      <Typography
        textStyle="b2"
        color="purple-1"
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap="8"
      >
        {children}
      </Typography>
    </Box>
  );
};

export default LabelBox;
